import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

export type PendingApproval = {
  type: "create_job" | "create_lead" | "create_task" | "schedule_appointment";
  parameters: Record<string, any>;
  spokenSummary: string;
};

interface Props {
  pending: PendingApproval | null;
  onApprove: () => void;
  onCancel: () => void;
}

const TITLE_MAP: Record<PendingApproval["type"], string> = {
  create_job: "Create job?",
  create_lead: "Create lead?",
  create_task: "Create task?",
  schedule_appointment: "Schedule appointment?",
};

function describe(p: PendingApproval): string {
  const params = p.parameters || {};
  switch (p.type) {
    case "create_job":
      return `Create a job for ${params.owner_name || "(no name)"} at ${params.property_address || "(no address)"}.`;
    case "create_lead":
      return `Create a lead for ${params.contact_name || "(no name)"}${params.contact_phone ? ` (${params.contact_phone})` : ""}.`;
    case "create_task":
      return `Create task: ${params.title || params.description || "(no description)"}.`;
    case "schedule_appointment":
      return `Schedule ${params.appointment_type || "appointment"} on ${params.scheduled_date || "(no date)"}.`;
  }
}

export function BridgetteApprovalDialog({ pending, onApprove, onCancel }: Props) {
  return (
    <AlertDialog open={!!pending} onOpenChange={(open) => !open && onCancel()}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{pending ? TITLE_MAP[pending.type] : "Confirm action"}</AlertDialogTitle>
          <AlertDialogDescription>
            {pending ? describe(pending) : ""}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={onCancel}>Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={onApprove}>Approve</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
